/* Optional hero add-on: one choice, one cart request, shared by the main and sticky CTA. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!root || !root.document) return;
  if (root.PGHeroAddon) return;
  root.PGHeroAddon = api;
  function init(scope) {
    scope.querySelectorAll('[data-hero-addon]').forEach(function (panel) {
      if (panel.dataset.initialized) return;
      panel.dataset.initialized = 'true';
      var section = panel.closest('.pg-pdp-hero-atf');
      var checkbox = panel.querySelector('[data-hero-addon-checkbox]');
      var preview = section.querySelector('[data-bundle-preview]');
      var fixedBase = Number(panel.dataset.baseCents || 0);
      var base = fixedBase > 0 ? fixedBase : preview ? Number(preview.dataset.baseCents) : Number(section.dataset.addonBaseCents || 0);
      var selectedTotal = Number(panel.dataset.selectedTotalCents || 0);
      var money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: root.Shopify && root.Shopify.currency ? root.Shopify.currency.active : 'USD'});
      function render() {
        var total = api.total(base, Number(panel.dataset.priceCents), checkbox.checked, selectedTotal);
        panel.querySelector('[data-hero-addon-total]').textContent = money.format(total / 100);
        section.querySelectorAll('[data-mobile-sticky-price]').forEach(function (el) {el.textContent = money.format(total / 100);});
      }
      // Optional bridge: the existing PG Bundle add-on still owns the cart item.
      // Match its paid variant so a hero change cannot select a different product.
      var bundleCheckbox = null;
      if (panel.dataset.syncBundleAddon === 'true') {
        document.querySelectorAll('[data-pgb-addon]').forEach(function (bundle) {
          if (panel.dataset.variantId && bundle.dataset.variantId === panel.dataset.variantId && bundle.dataset.available === 'true') {
            bundleCheckbox = bundle.querySelector('[data-pgb-addon-input]');
          }
        });
        if (!bundleCheckbox || panel.dataset.preview === 'true' || panel.dataset.available !== 'true') {
          checkbox.checked = false;
          checkbox.disabled = true;
          bundleCheckbox = null;
        } else {
          checkbox.checked = bundleCheckbox.checked;
          bundleCheckbox.addEventListener('change', function () {
            checkbox.checked = bundleCheckbox.checked;
            render();
          });
        }
      }
      section.addEventListener('pg:hero:price', function (e) {if (!(fixedBase > 0)) base = e.detail.cents; render();});
      checkbox.addEventListener('change', function () {
        if (bundleCheckbox && bundleCheckbox.checked !== checkbox.checked) {
          bundleCheckbox.checked = checkbox.checked;
          bundleCheckbox.dispatchEvent(new Event('change', {bubbles: true}));
        }
        render();
        section.dispatchEvent(new CustomEvent('pg:bundle-addon', {bubbles: true, detail: {action: checkbox.checked ? 'checked' : 'unchecked', template: panel.dataset.template, variantId: panel.dataset.variantId || null, preview: panel.dataset.preview === 'true'}}));
      });
      render();
    });
  }
  api.augment = async function (items, section) {
    var panel = section.querySelector('[data-hero-addon]');
    if (!panel || !panel.querySelector('[data-hero-addon-checkbox]').checked) return items;
    if (panel.dataset.preview === 'true' || panel.dataset.available !== 'true') throw new Error('The optional add-on is awaiting product setup. Please uncheck it to continue.');
    var response = await fetch(((root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/') + 'cart.js', {headers: {'Accept': 'application/json'}, credentials: 'same-origin'});
    if (!response.ok) throw new Error('Could not check your cart. Please try again.');
    var cart = await response.json();
    return api.append(items, cart.items, {variantId: panel.dataset.variantId, productId: panel.dataset.productId, template: panel.dataset.template, addonKey: panel.dataset.addonKey, addonName: panel.dataset.addonName, sellingPlanId: panel.dataset.sellingPlanId});
  };
  init(document);
  document.addEventListener('shopify:section:load', function (e) {init(e.target);});
})(typeof window !== 'undefined' ? window : null, function () {
  // A fixed ticked total shows what the cart charges when its discounts don't add up to base + add-on.
  function total(base, addon, selected, selectedTotal) {
    if (selected && selectedTotal > 0) return selectedTotal;
    return base + (selected ? addon : 0);
  }
  function append(items, cartItems, config) {
    var variantId = Number(config.variantId);
    if (!Number.isSafeInteger(variantId) || variantId <= 0) throw new Error('The optional add-on is not configured.');
    if (items.some(function (item) {return Number(item.id) === variantId;})) return items;
    if ((cartItems || []).some(function (item) {return Number(item.product_id) === Number(config.productId) || Number(item.variant_id) === variantId;})) {
      throw new Error((config.addonName || 'iON+') + ' is already in your cart. Uncheck the add-on to keep your existing selection.');
    }
    var item = {id: variantId, quantity: 1, properties: {_pg_bundle_addon: config.addonKey || 'ion-plus', _pg_bundle_template: config.template}};
    if (config.sellingPlanId) {
      var sellingPlanId = Number(config.sellingPlanId);
      if (!Number.isSafeInteger(sellingPlanId) || sellingPlanId <= 0) throw new Error('The optional add-on selling plan is not configured.');
      item.selling_plan = sellingPlanId;
    }
    return items.concat([item]);
  }
  return {total: total, append: append};
});
